(( $, wp ) => {

    const { __, _x, _n, _nx } = wp.i18n;
    const { Fragment } = wp.element;
    const { SelectControl, TextControl, PanelBody, PanelRow } = wp.components;
    if (typeof wp.blockEditor != "undefined") var { InspectorControls } = wp.blockEditor;
    else var { InspectorControls } = wp.editor;


    wp.blocks.registerBlockType( 'discord-wordpress-plugin/dwpp-invite-banner-gutenberg-block', {

        // Block setup
        title: __('Discord Invite Banner', 'discord-wordpress-plugin'),
        description: __('Widget displaying invitation banner.', 'discord-wordpress-plugin'),
        icon: <svg width="430" height="430" viewBox="0 0 430 430">
                <path fill="#729fda" d="M111.06,185.79h26.06l-13-37.56ZM248.19,174.5a16.94,16.94,0,1,0,16.92,16.94A17,17,0,0,0,248.19,174.5Zm79-135.5H33.84A33.87,33.87,0,0,0,0,72.88V276.13A33.87,33.87,0,0,0,33.84,310H327.16A33.87,33.87,0,0,0,361,276.13V72.88A33.87,33.87,0,0,0,327.16,39ZM176.68,242.25H164.73a11.3,11.3,0,0,1-10.66-7.59l-5.2-15H99.32l-5.2,15a11.28,11.28,0,0,1-10.66,7.59H71.51a11.29,11.29,0,0,1-10.66-15L98.71,118.13a16.92,16.92,0,0,1,16-11.38h18.8a16.92,16.92,0,0,1,16,11.38l37.85,109.12a11.29,11.29,0,0,1-10.65,15ZM299,231a11.28,11.28,0,0,1-11.28,11.29H276.39a11.1,11.1,0,0,1-8.45-4,50.94,50.94,0,1,1-2.83-94.5V118a11.28,11.28,0,0,1,11.28-11.29h11.28A11.28,11.28,0,0,1,299,118Z"/>
                <rect x="238" y="238" width="177" height="145" fill="white"/>
                <path fill="#7289DA" d="M355.17,317.14a10.72,10.72,0,0,1-10.69,10.71,11.06,11.06,0,0,1-7.62-3.18,10.3,10.3,0,0,1-3.07-7.45,10.72,10.72,0,0,1,10.69-10.71v0A10.66,10.66,0,0,1,355.17,317.14Zm-47.47-10.67,0,0A10.72,10.72,0,0,0,297,317.21a10.3,10.3,0,0,0,3.07,7.45,11.06,11.06,0,0,0,7.62,3.18,10.69,10.69,0,0,0,0-21.38ZM430,237.17V430l-25.28-20.36-13.83-12-15.15-12.52L382,404.88H249.65c-13.21,0-24-9.57-24-22.17V237.22c0-12,10.74-22.17,24-22.17l155.72,0C418.66,215,429.34,225.18,430,237.17ZM347.27,266l.32-.09h-.23Zm49.49,74.23c0-34.65-17.13-62.87-17.13-62.87-15.32-10.8-29.62-11.28-32.32-11.28l-1.74,1.63c19.56,5.38,29,13.76,29,13.76a109.65,109.65,0,0,0-87.07-3.61c-4.43,1.81-6.95,3-6.95,3s9.42-9,30.26-13.76l-1.28-1.19s-15.82-.57-32.82,11.37c0,0-17.05,28.13-16.89,63,0,0,9.42,15.61,35.29,16.18,0,0,3.75-4.81,7.59-9-14.54-4.19-20.2-12.57-20.2-12.57l4.85,2.38c14.21,5.55,29.25,12.56,56,8.37,5.62-1.23,11.29-2.42,17-4.8,3.67-1.81,8.19-3.61,13.17-6.61,0,0-5.65,8.38-20.79,12.57,3.11,4.19,7.5,9,7.5,9C386.16,355.19,396.22,339.61,396.77,340.24Z"/>
            </svg>,
        category: 'discord-wordpress-plugin-blocks',


        // Custom attributes
        attributes: {
            title: {
                type: 'string',
                default: __('Join our server', 'discord-wordpress-plugin'),
            },
            showCount: {
                type: 'string',
                default: 'show',
            },
            membersCount: {
                type: 'integer',
                default: 100,
            },
            link: {
                type: 'string',
                default: '0',
            },
            channels: {
                type: 'object',
                default: {
                    length: 0
                },
            },
        },

        example: {},


        // Main editor function
        edit: props => {

            // Updating channels list
            if (props.attributes.channels.length === 0) {
                $.get( ajaxurl, { action: 'dwpp_getAllChannelsList' } )
                    .done( response => {

                        let channels = [];
                        if (response.data.channels) {
                            response.data.channels.forEach(element => {
                                channels.push({
                                    value: element.id,
                                    label: element.name
                                });
                            });
                        }
                        props.setAttributes({ channels: channels });

                        if (props.attributes.showCount === 'show') {
                            $.get(ajaxurl, {action: 'dwpp_getMembersCount'})
                                .done(response => props.setAttributes({membersCount: response.data.count ?? 100}));
                        }
                    } );

                return __('Loading...', 'discord-wordpress-plugin');
            }

            if (!props.attributes.link || props.attributes.link === '0') {
                props.setAttributes({link: props.attributes.channels[0].value});
            }


            return [

                // Sidebar controls
                <Fragment>
                    <InspectorControls>
                        <PanelBody title={'View'} initialOpen={true}>
                            <PanelRow>
                                <TextControl
                                    label={ __('Text', 'discord-wordpress-plugin') }
                                    value={ props.attributes.title }
                                    onChange={ value => props.setAttributes({ title: value }) }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Show members count', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ showCount: value }) }
                                    options={[
                                        { value: 'show', label: __('Show', 'discord-wordpress-plugin') },
                                        { value: 'hide', label: __('Hide', 'discord-wordpress-plugin') }
                                    ]}
                                    value={ props.attributes.showCount }/>
                            </PanelRow>
                            <PanelRow>
                                <SelectControl
                                    label={ __('Invite to channel', 'discord-wordpress-plugin') }
                                    onChange={ value => props.setAttributes({ link: value }) }
                                    options={ props.attributes.channels }
                                    value={ props.attributes.link }/>
                            </PanelRow>
                        </PanelBody>
                    </InspectorControls>
                </Fragment>,

                // Output in editor
                <a className="dwpp_widget_banner dwpp_widget_banner_invite_banner">
                    <span className="dwpp_widget_banner__row">
                        <img
                            className="dwpp_widget__logo"
                            src="/wp-content/plugins/discord-wordpress-plugin/view/style/discord/images/icon-white.svg"
                            height="34"/>
                        <span className="dwpp_widget_banner__column">
                            <span className="dwpp_widget__title">
                                { props.attributes.title }
                            </span>
                            { props.attributes.showCount === 'show' ?
                                <span>
                                { __( 'Members count:', 'discord-wordpress-plugin' ) }
                                    &nbsp;
                                    { props.attributes.membersCount }
                                </span>
                            : ''}
                        </span>
                    </span>
                </a>
            ];
        },


        // Front end save
        save: () => {
            return null;
        },

    });
})( jQuery, wp );
